import styled from 'styled-components/macro';

export const Title = styled.div`
  color: #333;
  font-size: 21px;
  line-height: 24px;
  margin-bottom: 10px;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  & > * {
    margin-left: 11px;
  }
`;

export const TableWrapper = styled.div`
  margin-top: 20px;
`;